import constants from 'src/config/constants.ts'

const absenceStatusMixin = {
  computed: {
    absenceState () {
      const { deleted, read, updated, contacted, missing_parents } = constants.classbook.absences.status
      const { MISSING } = constants.classbook.absences.types.keys
      const isContacted = this.absence.last_contacted_at && this.$can('notify-parents', this.absence)

      if (this.absence.deleted_at) return deleted
      if (!this.absence.meta.has_active_parents && isContacted) return missing_parents
      if (isContacted) return contacted
      if (this.absence.read_at && this.$moment(this.absence.read_at).isBefore(this.absence.updated_at)) return updated
      if (this.absence.read_at && this.absence.type.category !== MISSING) return read

      return null
    },
    statusFlagTitle () {
      const { deleted, read, contacted, missing_parents } = constants.classbook.absences.status

      if (this.absenceState === missing_parents) return this.$t('classbook.absences.user_absences.missing_parents')
      if (this.absenceState === contacted) return this.$t('classbook.absences.user_absences.contacted')
      if (this.absenceState === deleted) return this.$t('classbook.absences.user_absences.deleted')
      if (this.absenceState === read) return this.$t('classbook.absences.user_absences.read')
      return this.$t('classbook.absences.user_absences.edited')
    },
    displayStatusFlag () {
      return !!this.absenceState
    }
  },

  methods: {
    getAbsenceStateBadge (absenceType) {
      if (!absenceType) return
      return {
        text: absenceType.name,
        color: this.getAbsenceTypeColor(absenceType),
        outline: absenceType.state === constants.classbook.absences.types.keys.PENDING,
        testId: `absence-state-${absenceType.state.toLowerCase()}`
      }
    },

    getAbsenceStateBadgeByAbsence (absence) {
      if (!absence?.type) return
      return this.getAbsenceStateBadge(absence.type)
    },

    getAbsenceStateBadgeByType (absenceType) {
      if (!absenceType) return
      return this.getAbsenceStateBadge(absenceType)
    },

    getAbsenceTypeColor (absenceType) {
      if (!absenceType) return ''
      const color = constants.classbook.absences.types.colors[absenceType.key === constants.classbook.absences.types.keys.MISSING ? absenceType.key : absenceType.state]
      const isOutlined = absenceType.state === constants.classbook.absences.types.keys.PENDING

      // fix dark badge text-color (can be removed, when we replace bootstrap badges with our own)
      return color.endsWith('dark') ? `${color} ${isOutlined ? '' : 'text-white'}` : color
    }
  }
}

export default absenceStatusMixin
